export const color = {
  primary: '#181741',
  secondary: '#373291',
  themesText4: '#e1473d',
  textPrimary: '#0c3558',
  gray: '#e8e9f082', // rgba(232, 233, 240, 0.51)
  grey: 'grey',
  BG_COLOR: '#FFFFFF',
  borderColor: '#ccb9c2',
  dark: '#202240',
  light: '#7d97f4',
  brawn: '#e9ad72',
  backgroundColor: '#eae3e9',
  overlay: 'rgba(0, 0, 0, 0.5)',
  lightBorder: '#E5E7EB',
};

export const storeCreateColors = {
  accent: color.primary,
  accentTint: '#ECEDF7',
};

export const appColors = {
  light: '#F1F2F3',
  dark: '#17171C',
  themesText: '#4B5EFC',
  btnGray: '#4E505F',
  btnDark: '#2E2F38',
  gray: '#747477',
  contentInk: '#000000',
  surfaceBase: '#FFFFFF',
  result: '#46D5B2',
  discountBadgeBg: '#DCFCE7',
  discountBadgeText: '#166534',
  strikethrough: '#888888',
  discountBannerBorder: '#004AC6',
  selectedBg: '#F0F8FF',
  selectedBorder: '#003F64',
  textDim: '#6D6D6D',
  textLight: '#878787',
  borderMedium: '#E0E0E0',
  inputBorder: '#E6E6E6',
  onboardingStart: '#CAC8E0',
  onboardingEnd: '#F5FAFE',
  activeDot: '#262467',
  inactiveDot: '#8E8E93',
  inputHighlight: '#F1ECFF',
  tabGradientStart: '#32307F',
  tabGradientEnd: '#6D69DE',
  discountGreen: '#00C853',
  previewBg: '#F9F9F9',
  textBlack: '#2B2B2B',
  placeholder: '#7D7D7D',
  borderLight: '#E7E7E7',
  disabledBg: '#CCCCDB',
  disabledText: '#9797AA',
  gradientStart: '#E3DAFF',
  gradientStartAlt: '#E2D9FF',
  softBorder: '#E5E7EB',
  textGray: '#6B7280',
  editBlue: '#0043C9',
  editGray: '#ACACBA',
  seeAllBg: '#F1ECFF',
  dropShadow: '#B0D2F2',
  pillSelectedBg: '#F1F9FF',
  brandDark: '#272A53',
  captionText: '#555555',
  subtitleGray: '#888888',
  switchTrackOff: '#767577',
  switchThumbOff: '#F4F3F4',
  modalOverlay: 'rgba(0, 0, 0, 0.5)',
  modalText: '#666666',
  accentBlue: '#2F5FED',
  dangerRed: '#FF0000',
  brandBlue: '#335bff',
  themeSecondaryAction: '#0000d7',
  invoicePaidIcon: '#00923a',
  salesInfoText: '#0369a1',
  loginHeadingText: '#0c3558',
  themeActiveText: '#0d6efd',
  themeInfoText: '#0dcaf0',
  returnIconStroke: '#17233d',
  themesText2: '#181741',
  themesText3: '#198754',
  summaryPrimaryText: '#1a1a1a',
  iconPrimaryStroke: '#1d2433',
  paymentCardChart: '#2196f3',
  statusPaidText: '#28a745',
  headerNavText: '#313131',
  statusNeutralText: '#333333',
  resendOtpText: '#3777c0',
  statusProcessingText: '#3b82f6',
  billModalHeadingText: '#4a505c',
  paymentUpiChart: '#4caf50',
  utilityIconStroke: '#515e7a',
  paymentExchangeChart: '#607d8b',
  refundedStatusText: '#64748b',
  toggleArrowStroke: '#6b00d8',
  summaryCaptionText: '#6c757d',
  themeFocusRing: '#86b7fe',
  statusShippedText: '#8b5cf6',
  paymentOtherChart: '#9c27b0',
  timerWarningText: '#a8a497',
  themeDisabledText: '#b0b3b8',
  graphPositiveGradientEnd: '#b5ddc2',
  salesInfoBorder: '#bae6fd',
  themeInputBorder: '#ced4da',
  toggleBorder: '#d1d1d3',
  statusPaidBg: '#d2ffe5',
  statusPaidSoftBg: '#d4edda',
  themeDestructiveText: '#dc2626',
  themeErrorBase: '#dc3545',
  graphNegativeGradientEnd: '#ddb5b5',
  dividerBorder: '#dddddd',
  deleteIconStroke: '#e02d3c',
  checkboxBorderStroke: '#e4e7ec',
  settingsAccentSurface: '#e6e6fa',
  profitPositiveBg: '#e8f5e8',
  themeHoverBg: '#e9ecef',
  featureIconBg: '#ebebeb',
  validationErrorText: '#ee0000',
  statusProcessingBg: '#eff6ff',
  salesInfoBg: '#f0f9ff',
  refundedStatusBg: '#f1f5f9',
  paymentCreditChart: '#f44336',
  statusReturnedText: '#f59e0b',
  statusShippedBg: '#f5f3ff',
  inactiveStateBg: '#f5f5f5',
  otpInputBg: '#f6f6fb',
  selectActiveBg: '#f6f7f8',
  themeGradientSurface: '#f8f9fa',
  themePageBg: '#f9fafc',
  statusCancelledBg: '#fee2e2',
  customerStatusErrorBg: '#fef2f2',
  fileuploaderText: '#ff4d4f',
  paymentCashChart: '#ff9800',
  statusDueText: '#ffc107',
  themeDestructiveBg: '#ffd2d2',
  profitLossNegativeBg: '#ffe8e8',
  statusDueBg: '#fff3cd',
  statusReturnedBg: '#fffbeb',
  errorText: '#ef4444',
  inputBorderStrong: '#d1d5db',
  linkBlue: '#0000ee',
  lossRed: '#d32f2f',
  panelHoverBg: '#f9fafb',
  panelMutedBg: '#f3f4f6',
  placeholderMuted: '#9ca3af',
  profitGreen: '#2e7d32',
  themeDisabledBg: 'rgb(224, 224, 224)',
  themeInputDisabledText: 'rgb(71, 71, 71)',
  themeDarkSurface: 'rgba(10, 13, 20, 1)',
  themeWarningPressed: 'rgba(128, 70, 13, 1)',
  themeWarningHover: 'rgba(150, 83, 15, 1)',
  themeErrorPressed: 'rgba(152, 27, 37, 1)',
  mutedBorderOverlay: 'rgba(176, 179, 184, 0.4)',
  themeWarningBase: 'rgba(178, 94, 9, 1)',
  themeErrorHover: 'rgba(186, 37, 50, 1)',
  themePrimaryPressed: 'rgba(18, 28, 49, 1)',
  carouselSlideBg: 'rgba(210, 231, 255, 1)',
  featureTealIconBg: 'rgba(212, 230, 228, 0.65)',
  themeErrorText: 'rgba(224, 45, 60, 1)',
  themeNeutralBorder: 'rgba(225, 230, 239, 1)',
  themeAccentSoftBg: 'rgba(229, 222, 255, 1)',
  themeSuccessSoftBg: 'rgba(237, 253, 248, 1)',
  themePrimarySoftBg: 'rgba(240, 245, 255, 1)',
  themeNeutralSecondaryBg: 'rgba(241, 243, 249, 1)',
  featureErrorIconBg: 'rgba(248, 221, 221, 0.75)',
  themeSecondarySoftBg: 'rgba(248, 244, 232, 1)',
  themeNeutralBase: 'rgba(248, 249, 252, 1)',
  themeErrorSoftBg: 'rgba(254, 241, 242, 1)',
  authSurface: 'rgba(255, 244, 224, 1)',
  themeWarningSoftBg: 'rgba(255, 248, 235, 1)',
  themeDarkDisabledText: 'rgba(255, 255, 255, 0.6)',
  themeDarkSecondaryText: 'rgba(255, 255, 255, 0.75)',
  themeDarkPrimaryText: 'rgba(255, 255, 255, 1)',
  themeDarkNeutralPrimary: 'rgba(27, 31, 39, 1)',
  themeDisabledTextOverlay: 'rgba(29, 36, 51, 0.65)',
  themeSecondaryText: 'rgba(29, 36, 51, 0.8)',
  themeBodyText: 'rgba(29, 36, 51, 1)',
  themeDarkNeutralSecondary: 'rgba(35, 39, 47, 1)',
  themePrimaryHover: 'rgba(46, 57, 80, 1)',
  themeSuccessHover: 'rgba(4, 114, 77, 1)',
  themeDarkNeutralLine: 'rgba(63, 68, 77, 1)',
  themeSuccessPressed: 'rgba(6, 96, 66, 1)',
  themeSuccessText: 'rgba(8, 135, 93, 1)',
  shadowLight: 'rgba(0, 0, 0, 0.1)',
  shadowOverlay: 'rgba(0, 0, 0, 0.2)',
  successBg: '#ecfdf5',
  successText: '#10b981',
  otpTimerText: '#14539a',
};

export const expenseCategoryColors: Record<string, string> = {
  'Taxes & Statutory': '#C62828',
  'Direct Expenses': '#2E7D32',
  Miscellaneous: '#9E9E9E',
  'Advertising & Marketing': '#EF6C00',
  'Professional Services': '#7B1FA2',
  'Operational Expenses': '#546E7A',
  'Finance & Banking': '#006064',
  Payroll: '#00A86B',
  'Technology & Subscriptions': '#1565C0',
  'Purchase Product': '#8D6E63',
  'Transportation & Travel': '#FFB300',
  Other: '#CFD8DC',
};